import styled from 'styled-components';

import { scale110 } from '@xing-com/tokens';

export const Button = styled.span`
  font-size: ${scale110};
  line-height: 2.66em;
  font-family: VideoJS;
  font-style: normal;
  font-weight: normal;
  &::before {
    content: '\f114';
  }
`;
